import styled from 'styled-components';

export const ToastContainer = styled.div`
  position: fixed;
  bottom: 24px;
  right: 24px;
  min-width: 300px;
  max-width: 90%;
  width: fit-content;
  max-width: min(90%, 500px); /* Limita a largura máxima */
  background: ${({ $context }) => ($context === 'error' ? '#DA4336' : '#1F2044')};
  color: ${({ $context }) => ($context === 'error' ? '#FFFFFF' : '#CDD8DF')};
  border-radius: 8px;
  padding: 16px;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  animation: slideIn 0.3s ease-out;

  @keyframes slideIn {
    from {
      transform: translateX(-50%) translateY(100%);
      opacity: 0;
    }
    to {
      transform: translateX(-50%) translateY(0);
      opacity: 1;
    }
  }
`;

export const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0; /* Permite que o texto quebre linha */
`;

const getTitleColor = ({ $context }) => {
  if ($context === 'error') return '#FFFFFF';
  if ($context === 'success') return '#35CF8B';
  if ($context === 'warning') return '#FF9442';
  return '#74C1FF';
};

export const Title = styled.h4`
  margin: 0;
  color: ${getTitleColor};
  font-size: 16px;
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Message = styled.p`
  margin: 0;
  font-size: 14px;
  word-wrap: break-word; /* Quebra palavras longas */
  overflow-wrap: break-word; /* Melhor para quebra de palavras */
  white-space: pre-line; /* Respeita quebras de linha e quebra automaticamente */
`;

export const CloseButton = styled.button`
  background: transparent;
  border: none;
  color: inherit;
  cursor: pointer;
  padding: 0;
  margin-left: 8px;
  flex-shrink: 0; /* Evita que o botão diminua */
`;
